export const PRIMARY_STACK_CLASS_NAME = 'primary-stack';
export const SUMMARY_PREVIEW_INFO_LIST_STACK_CLASS_NAME = 'summary-preview-info-list-stack';
export const SUMMARY_PREVIEW_INFO_ITEM_STACK_CLASS_NAME = 'summary-preview-info-item-stack';
export const SECONDARY_STACK_CLASS_NAME = 'secondary-stack';
export const SUCCESS_STACK_CLASS_NAME = 'success-stack';
export const WARNING_STACK_CLASS_NAME = 'warning-stack';
export const PENDING_STACK_CLASS_NAME = 'pending-stack';
export const DASHED_WARNING_STACK_CLASS_NAME = 'dashed-warning-stack';
export const DASHED_GRAY_STACK_CLASS_NAME = 'dashed-gray-stack';
export const ICON_STACK_CLASS_NAME = 'icon-stack';
export const INFORMATION_STACK_CLASS_NAME = 'information-stack';
export const UPLOAD_DOCUMENT_STACK_CLASS_NAME = 'upload-document-stack';
export const DASHED_OUTLINE_STACK_CLASS_NAME = 'dashed-outline-stack';
export const HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME = 'highlighted-upload-document-stack';
export const COLORED_BORDERED_STACK_CLASS_NAME = 'colored-bordered-stack';
export const BORDERED_BACKGROUND_STACK_CLASS_NAME = 'bordered-background-stack';
export const PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME = 'primary-confirmation-icon-stack';
export const SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME = 'success-confirmation-icon-stack';
export const WARNING_ICON_STACK_CLASS_NAME = 'warning-icon-stack';
export const SELECTABLE_CARD_STACK_CLASS_NAME = 'selectable-card-stack';
export const SELECTABLE_CARD_STACK_ACTIVE_CLASS_NAME = 'active';
export const SELECTABLE_CARD_LINK_STACK_CLASS_NAME = 'selectable-card-link-stack';
export const VERTICAL_SCROLL_STACK_CLASS_NAME = 'vertical-scroll-stack';
export const PRIMARY_VERTICAL_DIVIDERS_STACK_CLASS_NAME = 'primary-vertical-dividers-stack';
